import { createSelector } from 'reselect';
import { getEntityByName } from '../../../appEntities';
import { get, isEqual } from 'lodash';
import {
    EDIT_RULES_FAILURE,
    EDIT_RULES_LOAD,
    EDIT_RULES_SUCCESS,
    RULES_FAILURE,
    RULES_LOAD,
    RULES_SUCCESS
} from './rulesActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case EDIT_RULES_FAILURE:
            newState = {
                ...state,
                editRulesError: action.error,
                isEditRulesLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_RULES_LOAD:
            newState = {
                ...state,
                editRulesError: null,
                isEditRulesLoading: true,
                isEditRulesSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_RULES_SUCCESS:
            newState = {
                ...state,
                isEditRulesLoading: false,
                isEditRulesSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case RULES_LOAD:
            newState = {
                ...state,
                isRulesLoading: true,
                isRulesLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case RULES_SUCCESS:
            newState = {
                ...state,
                count: 100000,
                pages: 1,
                rules: action.rules,
                isRulesLoading: false,
                isRulesLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        case RULES_FAILURE:
            newState = {
                ...state,
                count: 0,
                isRulesLoading: false,
                pages: 0,
                rules: [],
                isRulesLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getRulesEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'rules')
);

export const getIsEditRulesLoading = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'isEditRulesLoading')
);

export const getIsEditRulesSuccessful = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'isEditRulesSuccessful')
);

export const getEditRulesError = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'editRulesError')
);

export const getEditRulesErrorMessage = createSelector(
    getEditRulesError,
    (error) => get(error, 'message')
);

export const getCount = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'count')
);

export const getPages = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'pages')
);

export const getRules = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'rules')
);

export const getIsRulesLoading = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'isRulesLoading')
);

export const getIsRulesLoaded = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'isRulesLoaded')
);

export const getRulesError = createSelector(
    getRulesEntity,
    (entity) => get(entity, 'rulesError')
);

export const getRulesErrorMessage = createSelector(
    getRulesError,
    (error) => get(error, 'message')
);
